// extracted by mini-css-extract-plugin
export default {"block":"VnULk3","block__text":"aHP2mb"};